  // src/components/BookGrid.jsx
  import React from "react";
  import { AnimatePresence, motion } from "framer-motion";
import { Grid as GridIcon, List as ListIcon } from "lucide-react";
  import BookCard from "../homePageComponents/BookCard";
  import SkeletonCard from "../uiComponents/SkeletonCard";
  import BookListItem from "../homePageComponents/BookList";

  const PAGE_SIZE = 30;

  const BookGrid = ({
    books = [],
    view = "grid",
    onViewChange,
    loading = false,
    categoryFilter,
    firstPageReady = true, // new
    page = 0, // new
  }) => {

    // Always show PAGE_SIZE skeletons while loading
    const placeholderCount = PAGE_SIZE;

    return (
      <div className="bg-primary-shade1 p-4 rounded-lg">
        {/* Category Filter and View Toggle - side by side */}
        <div className="flex items-center justify-between flex-wrap gap-4 mb-4">
          <div className="flex-1 min-w-[200px]">{categoryFilter}</div>

          {/* View Toggle */}
          {onViewChange && (
            <div className="flex justify-end space-x-2">
              <button
                onClick={() => onViewChange("grid")}
                className={`p-2 rounded-md transition ${
                  view === "grid"
                    ? "bg-[#FF7236] text-white"
                    : "text-[#FF7236] hover:bg-[#FFD8C7]"
                }`}
              >
                <GridIcon size={20} />
              </button>
              <button
                onClick={() => onViewChange("list")}
                className={`p-2 rounded-md transition ${
                  view === "list"
                    ? "bg-[#FF7236] text-white"
                    : "text-[#FF7236] hover:bg-[#FFD8C7]"
                }`}
              >
                <ListIcon size={20} />
              </button>
            </div>
          )}
        </div>

        {/* Grid View */}
        {view === "grid" ? (
          loading ? (
            <div className="flex justify-center">
              <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-6 gap-8">
                {Array.from({ length: placeholderCount }).map((_, i) => (
                  <SkeletonCard key={i} />
                ))}
              </div>
            </div>
          ) : (
            <div className="flex justify-center">
              <div
                className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 w-full"
                style={{
                  contentVisibility: "auto",
                  containIntrinsicSize: "300px",
                }}
              >
                {books.map((book, i) => (
                <motion.div
    key={book.id}
    // if first page not ready, avoid the translate-y (reduces flicker); when ready use subtle fade+move
    initial={firstPageReady ? { opacity: 0, y: 12 } : { opacity: 0 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{
      delay: Math.min(i * 0.01, 0.16),
      duration: 0.22,
      ease: "easeOut",
    }}
  >
    <BookCard book={book} />
  </motion.div>

                ))}
              </div>
            </div>
          )
        ) : (
          /* List View */
          <AnimatePresence>
            <div className="space-y-4">
              {loading
                ? Array.from({ length: placeholderCount }).map((_, i) => (
                    <SkeletonCard key={i} />
                  ))
                : books.map((book, i) => (
                    <motion.div
                      key={book.id}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -20 }}
                      transition={{
                        delay: i * 0.03,
                        type: "spring",
                        stiffness: 120,
                      }}
                    >
                      <BookListItem book={book} />
                    </motion.div>
                  ))}
            </div>
          </AnimatePresence>
        )}
      </div>
    );
  };

  export default BookGrid;
